const channelInstances = {}

export const getSingletonChannel = (name) => {
    if (!channelInstances[name]) {
        channelInstances[name] = new BroadcastChannel(name)
    }

    return channelInstances[name]
}
